module.exports = __webpack_public_path__ + "img/frail.686d64cb.svg";